export default __webpack_public_path__ + "static/media/bs-secondary-other.98eeb398.svg";